interface CooccurrenceIconProps {
  size?: number;
  fillColor?: string;
}

export const CooccurrenceIcon = ({
  size = 24,
  fillColor = '#0097A7',
}: CooccurrenceIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0711 6.34315C19.46 5.95424 19.46 5.31784 19.0711 4.92894C18.6822 4.54003 18.0458 4.54003 17.6569 4.92894L14.7577 7.82807C12.8202 6.54114 10.1757 6.75327 8.46447 8.46447C6.75327 10.1757 6.54114 12.8202 7.82807 14.7577L4.92894 17.6569C4.54003 18.0458 4.54003 18.6822 4.92894 19.0711C5.31784 19.46 5.95424 19.46 6.34315 19.0711L9.24229 16.1719C11.1798 17.4589 13.8243 17.2467 15.5355 15.5355C17.2467 13.8243 17.4589 11.1798 16.1719 9.24229L19.0711 6.34315ZM14.1213 14.1213C12.9475 15.2951 11.0525 15.2951 9.87868 14.1213C8.70489 12.9475 8.70489 11.0525 9.87868 9.87868C11.0525 8.70489 12.9475 8.70489 14.1213 9.87868C15.2951 11.0525 15.2951 12.9475 14.1213 14.1213Z"
        fill={fillColor}
      />
    </svg>
  );
};
